// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { DnaSyngoviaHealthcheckSummary } from '../../interfaces/dna-syngovia-healthcheck-data';
import { DnaSyngoviaScoreSeverityService } from '../../services/dna-syngovia-score-severity.service';

@Component({
  standalone: true,
  imports: [CommonModule, SharedModule, TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-dna-syngovia-healthcheck-summary',
  templateUrl: './dna-syngovia-healthcheck-summary.component.html',
  styleUrls: ['./dna-syngovia-healthcheck-summary.component.scss'],
})
export class DnaSyngoviaHealthcheckSummaryComponent {
  @Input({ required: true }) healthcheckSummary!: DnaSyngoviaHealthcheckSummary;

  public constructor(
    protected readonly dnaSyngoviaScoreSeverityService: DnaSyngoviaScoreSeverityService
  ) {}
}
